import { useMutation } from '@tanstack/react-query';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { StyledModal } from '@components/modal/ModalStyle';
import Input from '@components/form/Input';

import { copyProject } from '@utils/api';

const CopyModal = ({ project, show, setShow }) => {

	const copyProjectToUserMutation = useMutation({
		mutationFn: ({ projectId, email }) => copyProject({ email, projectId }),
		onSuccess: () => {
			window.alert('project is being copied. this will take a few minutes');
			setShow(false);
		},
		onError: err => {
			console.log(err);
			window.alert('Something went wrong');
		},
	});

	return (
		<StyledModal
			variant="dark"
			show={show}
			centered={true}
			onHide={() => {
				setShow(false);
			}}>
			<Modal.Header closeButton closeVariant="white">
				<Modal.Title>{'Copy Project to user'}</Modal.Title>
			</Modal.Header>

			<Form
				onSubmit={async e => {
					e.preventDefault();
					const email = e.target.elements[0].value;

					copyProjectToUserMutation.mutate({
						projectId: project?.uuid,
						email,
					});
				}}>
				<Modal.Body>
					<p>
						copy <strong>{project?.title}</strong> to another user
					</p>

					<Input
						label="Target user email"
						defaultValue=""
						id="targetEmail"
						helperText="Enter the email for the user that is to recieve a copy of this project."
						type="text"
						required
					/>
				</Modal.Body>

				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShow(false)}>
						Nah
					</Button>
					<Button
						variant="success"
						type="submit"
						disabled={copyProjectToUserMutation.isLoading}>
						Do it!
					</Button>
				</Modal.Footer>
			</Form>
		</StyledModal>
	);
};
export default CopyModal;
